import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NewYearAudioContextService {
  private readonly audioContext: AudioContext;

  constructor() {
    this.audioContext = new AudioContext();
  }

  get context(): AudioContext {
    return this.audioContext;
  }
}
